<template>
  <div class="news-container">
    <div class="main-width news-list">
      <div class="news-left">
        <v-title title="最新动态" url="/views/news/lastNews" color="#3272A9" />
        <div class="news-item" v-for="(item, index) in lastNewsList" :key="index">
          <LastNews :info="item"></LastNews>
        </div>
      </div>
      <div class="news-right">
        <v-title title="通知公告" url="/views/news/notice" color="#3272A9" />
        <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
          <Notice :info="item"></Notice>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VTitle from "./components/title/index";
import LastNews from "./components/news/lastNews";
import Notice from "./components/news/notice";
export default {
  data() {
    return {

    }
  },
  props: {
    lastNewsList: {
      type: Array,
      default: () => []
    },
    noticeList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VTitle, LastNews, Notice
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.news-container {
  padding: 30px 0;
  .news-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .news-left {
      width: 66%;
      padding-right: 20px;
      .news-item {
        margin: 14px 0;
      }
    }
    .news-right {
      width: 34%;
      background: #e6f4fe;
      padding: 0 20px;
      .notice-item {
        margin: 14px 0;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .news-container {
    padding: 14px 0;
    .news-list {
      justify-content: center;
      flex-direction: column;
      .news-left {
        width: 100%;
        padding-right: 0;
        .news-item {
          margin: 14px 0;
          padding-bottom: 14px;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .news-right {
        width: 100%;
        padding: 0 14px;
        .notice-item {
          margin: 14px 0;
        }
      }
    }
  }
}
</style>